export const MOL_V1ResourcesDE: MOL_V1ResourcesBSInterface = {
  labelDone: "Datum der Aufgabenerledigung",
  errors: {
    registerPic: "Das Bild, das Sie hochladen, ist zu groß.",
    recordAlreadyExists:
      "Diese Evidenz wurde bereits ausgefüllt. Sie können sie nicht erneut ausfüllen.",
  },
  errorMissingInput: "Bitte füllen Sie alle Felder aus",
  input: {
    signatureTitle: "Unterschrift",
    datum: {
      label: "Datum",
      placeholder: "Bitte geben Sie das Datum ein",
      name: "datum",
    },
    opis: {
      label: "Beschreibung",
      placeholder: "Bitte geben Sie eine Beschreibung ein",
      name: "opis",
    },
    izvrsioc: {
      label: "Arbeitsausführender",
      placeholder: "Bitte geben Sie den Arbeitsausführenden ein",
      name: "izvrsioc",
    },
    potpisIzvrsioca: {
      label: "Unterschrift des Arbeitsausführenden",
    },
  },
  evidencijaForm: {
    buttonForward: "Unterschreiben",
    buttonBack: "Zurück",
  },
  successModal: {
    title: "Dateneingabe",
    body: "Das Hinzufügen von Daten wurde erfolgreich abgeschlossen. Wählen Sie OK zum Fortfahren.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "Durch die Auswahl der Option Unterschreiben bestätige ich, dass die Aufgabe gemäß den Anweisungen ausgeführt wurde!",
};

interface InputField {
  label: string;
  placeholder?: string;
  name?: string;
}

interface Input {
  signatureTitle: string;
  datum: InputField;
  opis: InputField;
  izvrsioc: InputField;
  potpisIzvrsioca: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface MOL_V1ResourcesBSInterface {
  labelDone: string;
  errorMissingInput: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errors: IErrors;
}
